import { MessagingChannelReplyMode, PrincipalType } from '@treadinc/horizon-api-spec';

import { MessagingChannel, principalId } from '~hooks/useMessaging/models';
import { Nullable } from '~types/Nullable';

/** Fails closed: a non-user organizer or an unhydrated viewer answers false. */
export const isChannelOrganizer = (
  channel: MessagingChannel,
  viewerUserId: Nullable<string> | undefined,
) =>
  Boolean(viewerUserId) &&
  channel.organizer.type === PrincipalType.USER &&
  principalId(channel.organizer) === viewerUserId;

export type ComposerUnavailableReason = 'archived' | 'replies_off';

export const composerUnavailableReason = (
  channel: MessagingChannel,
  viewerUserId: Nullable<string> | undefined,
): Nullable<ComposerUnavailableReason> => {
  if (channel.isArchived) {
    return 'archived';
  }

  if (
    channel.replyMode === MessagingChannelReplyMode.ONE_WAY &&
    !isChannelOrganizer(channel, viewerUserId)
  ) {
    return 'replies_off';
  }

  return null;
};

/** A `reply_to_sender` channel is postable by everyone; the send routes the reply. */
export const canPostToChannel = (
  channel: Nullable<MessagingChannel> | undefined,
  viewerUserId: Nullable<string> | undefined,
) => (channel ? composerUnavailableReason(channel, viewerUserId) === null : false);
